import {gsap} from 'gsap';
import { Power1, TimelineMax } from 'gsap';


export default function animations() {
  gsap.registerPlugin(TimelineMax);
  var element = $('.scroll-down');
  var tl = new TimelineMax({ repeat: -1, repeatDelay: 0.5 });

  tl.to(element, 0.4, { y: '12', ease: Power1.easeNone });
  tl.to(element, 0.2, { y: '0', ease: Power1.easeOut });
  tl.to(element, 0.2, { y: '8', ease: Power1.easeNone });
  tl.to(element, 0.4, { y: '0', ease: Power1.easeOut });

}



// WEBPACK FOOTER //
// ./scripts/modules/animations.js